import React from 'react';
import { useSeo } from '../utils/seo';
import '../styles/Help.css';

const Help = () => {
  useSeo({
    title: 'Gigtos Help Center - Customer And Worker Support',
    description: 'Get help with Gigtos bookings, worker onboarding, Smart Queue, direct payments, and support workflows.',
    path: '/#/help',
    keywords: 'Gigtos help, Gigtos support, worker help, booking help, direct payment support',
  });

  const helpCategories = [
    {
      id: 'customer',
      title: 'Customer Help',
      description: 'FAQs and guides for customers booking services',
      icon: 'C',
      path: '/help/customer.html',
    },
    {
      id: 'worker',
      title: 'Worker Help',
      description: 'Resources for workers and service providers',
      icon: 'W',
      path: '/help/worker.html',
    },
    {
      id: 'admin',
      title: 'Admin Help',
      description: 'Administrative tools and management guides',
      icon: 'A',
      path: '/help/admin.html',
    },
  ];

  const handleCategoryClick = (path) => {
    // Use window.location for external paths
    window.location.href = path;
  };

  return (
    <div className="help-page">
      <div className="help-header">
        <h1>Help Center</h1>
        <p>Find answers and resources to get the most out of Gigtos</p>
      </div>

      <div className="help-content">
        <div className="categories-grid">
          {helpCategories.map((category) => (
            <div
              key={category.id}
              className="category-card"
              onClick={() => handleCategoryClick(category.path)}
            >
              <div className="category-icon">{category.icon}</div>
              <h3>{category.title}</h3>
              <p>{category.description}</p>
              <button className="view-btn">View Guide</button>
            </div>
          ))}
        </div>

        <div className="faq-section">
          <h2>Quick FAQs</h2>
          <div className="faq-items">
            <div className="faq-item">
              <h4>How do I book a service?</h4>
              <p>Use our smart booking system to describe your service needs. Our AI will guide you through the process step by step.</p>
            </div>
            <div className="faq-item">
              <h4>How do workers accept jobs?</h4>
              <p>Workers can browse open jobs in their area and apply directly. They can also see future scheduled work.</p>
            </div>
            <div className="faq-item">
              <h4>What payment methods are accepted?</h4>
              <p>For MVP jobs, consumers pay the worker directly after work completion. Gigtos does not charge a consumer subscription or job commission.</p>
            </div>
            <div className="faq-item">
              <h4>How can I contact support?</h4>
              <p>Email us at support@gigtos.app or use the contact form on our website. We respond within 24 hours.</p>
            </div>
          </div>
        </div>

        <div className="contact-section">
          <h2>Need More Help?</h2>
          <p>Can't find what you're looking for?</p>
          <a href="mailto:support@gigtos.app" className="contact-btn">
            Email Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default Help;
